import React from "react";
import { languages } from "../constants/languages";
import Typography from "@material-ui/core/Typography";
import HeaderBar from "../components/header/HeaderBar";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import moment from "moment-timezone";

import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import { Tooltip } from "@material-ui/core";
import HelpIcon from "@material-ui/icons/HelpOutline";

export default class Account extends React.Component {
  render() {
    return (
      <div
        style={{
          width: "100%",
          paddingTop: 20,
          paddingBottom: 50,
          marginTop: 64,
        }}
      >
        {this.props.userDataLoaded && (
          <div>
            <HeaderBar
              user={this.props.user}
              account
              handleBack={this.props.handleBack}
              userData={this.props.userData}
            />
            <div
              style={{
                width: 400,
                padding: 8,
                maxWidth: "97%",
                margin: "auto",
              }}
            >
              <Typography variant="h6">{languages.header.account}</Typography>
              <TextField
                style={{ marginTop: 20 }}
                fullWidth
                label={languages.login.email}
                name="email"
                disabled
                value={this.props.user.email}
              />
              <FormHelperText>
                {languages.account.changeEmailMessage}
                <Tooltip
                  title={languages.account.changeEmailMessageDescription}
                >
                  <HelpIcon
                    style={{
                      height: 15,
                      width: 15,
                      marginLeft: 5,
                      position: "relative",
                      top: 2,
                    }}
                  />
                </Tooltip>
              </FormHelperText>

              <TextField
                style={{ marginTop: 20 }}
                fullWidth
                label={languages.login.firstName}
                name="firstName"
                value={this.props.userData.firstName || ""}
                onChange={this.props.handleNameChange}
              />

              <FormControl style={{ marginTop: 20, width: "100%" }}>
                <InputLabel htmlFor="timezone">
                  {languages.general.timezone}
                </InputLabel>
                <Select
                  native
                  value={this.props.userData.timezone || "Europe/Amsterdam"}
                  onChange={this.props.handleTimezoneChange}
                  inputProps={{
                    name: "timezone",
                    id: "timezone",
                  }}
                >
                  {moment.tz.names().map((key) => {
                    return (
                      <option key={key} value={key}>
                        {key}
                      </option>
                    );
                  })}
                </Select>
                <FormHelperText>
                  {languages.general.timezoneText}
                </FormHelperText>
              </FormControl>

              {this.props.passwordChangeSuccess ? (
                <Typography style={{ marginTop: 35, color: "green" }}>
                  {languages.account.passwordChangeSuccess}
                </Typography>
              ) : (
                <Button
                  style={{ marginTop: 35, marginRight: 10 }}
                  variant="outlined"
                  color="default"
                  onClick={this.props.toggleChangePasswordDialog}
                >
                  {languages.account.changePassword}
                </Button>
              )}
              <Dialog
                open={this.props.changePasswordDialogOpen}
                onClose={this.props.toggleChangePasswordDialog}
                aria-labelledby="form-dialog-title"
                disableBackdropClick
                disableEscapeKeyDown
              >
                <DialogTitle id="form-dialog-title">
                  {languages.account.changePassword}
                </DialogTitle>
                <DialogContent style={{ width: 350, maxWidth: "97%" }}>
                  <DialogContentText>
                    {this.props.description}
                  </DialogContentText>
                  <TextField
                    type="password"
                    name="currentPassword"
                    label={languages.account.currentPassword}
                    value={this.props.currentPassword}
                    onChange={this.props.handleChange}
                    style={{ marginTop: 20 }}
                    fullWidth
                  />
                  {(this.props.errorMessage || "").length > 0 && (
                    <DialogContentText style={{ color: "red" }}>
                      {this.props.errorMessage}
                    </DialogContentText>
                  )}
                  <TextField
                    type="password"
                    name="password"
                    label={languages.account.newPassword}
                    value={this.props.password}
                    onChange={this.props.handleChange}
                    style={{ marginTop: 20 }}
                    fullWidth
                  />
                  <TextField
                    type="password"
                    name="passwordConfirm"
                    label={languages.account.repeatNewPassword}
                    value={this.props.passwordConfirm}
                    onChange={this.props.handleChange}
                    style={{ marginTop: 20 }}
                    fullWidth
                  />
                  {(this.props.errorMessageNew || "").length > 0 && (
                    <DialogContentText style={{ color: "red" }}>
                      {this.props.errorMessageNew}
                    </DialogContentText>
                  )}
                  <br />
                  <br />
                  {this.props.sent ? (
                    <DialogContentText style={{ color: "green" }}>
                      {languages.login.resetEmailSent}
                    </DialogContentText>
                  ) : (
                    <div>
                      <DialogContentText
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                          color: "black",
                        }}
                        onClick={
                          this.props.buttonDisabled
                            ? null
                            : this.props.sendPasswordResetEmail
                        }
                      >
                        {languages.formatString(
                          languages.account.orSendPasswordResetMailTo,
                          this.props.user.email
                        )}
                      </DialogContentText>
                      {(this.props.errorMessageResetEmail || "").length > 0 && (
                        <DialogContentText style={{ color: "red" }}>
                          {this.props.errorMessageResetEmail}
                        </DialogContentText>
                      )}
                    </div>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.props.toggleChangePasswordDialog}
                    color="primary"
                  >
                    {languages.general.cancel}
                  </Button>
                  <Button
                    onClick={this.props.handleChangePassword}
                    variant="contained"
                    color="primary"
                  >
                    {languages.general.save}
                  </Button>
                </DialogActions>
              </Dialog>

              <Button
                style={{ marginTop: 35 }}
                variant="outlined"
                color="secondary"
                onClick={this.props.toggleDeleteAccountDialog}
              >
                {languages.account.deleteAccount}
              </Button>
              <Dialog
                open={this.props.deleteAccountDialogOpen}
                onClose={this.props.toggleDeleteAccountDialog}
                aria-labelledby="form-dialog-title"
                disableBackdropClick
                disableEscapeKeyDown
              >
                <DialogTitle id="form-dialog-title">
                  {languages.account.deleteAccount}
                </DialogTitle>
                <DialogContent style={{ width: 350, maxWidth: "97%" }}>
                  <DialogContentText>
                    {languages.account.deleteAccountConfirm}
                  </DialogContentText>
                  <TextField
                    fullWidth
                    type="email"
                    label={languages.login.email}
                    value={(window.firebase.auth().currentUser || {}).email}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="password"
                    label={languages.login.password}
                    value={this.props.reAuthPassword}
                    onChange={this.props.handleChange}
                    name="reAuthPassword"
                  />
                  {this.props.errorMessageReAuth && (
                    <DialogContentText style={{ color: "red" }}>
                      {this.props.errorMessageReAuth}
                    </DialogContentText>
                  )}
                  {this.props.deleteConfirm && (
                    <DialogContentText style={{ color: "red" }}>
                      {languages.tournament.areYouSure}
                    </DialogContentText>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.props.toggleDeleteAccountDialog}
                    color="primary"
                  >
                    {languages.general.cancel}
                  </Button>
                  <Button
                    onClick={this.props.handleDeleteAccount}
                    variant="contained"
                    color="secondary"
                  >
                    {languages.general.delete}
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          </div>
        )}
      </div>
    );
  }
}
